/* eslint-disable react/prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unescaped-entities */
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import PropTypes from 'prop-types';
import CornerSpinner from 'components/CornerSpinner';
import {
  FolderIcon,
  CrossIcon,
  Edit,
  Delete,
  MoveIcon2,
  GreaterArrow,
  DuplicateIcon,
  Icon,
} from 'utils/icons';
import remove from 'assets/images/remove.png';
import { useHomeScreenContext } from 'layouts/HomeScreenLayout/contexts/HomeScreenContext';
import MoveBudgets from '../../components/MoveBudgets';
import { toast } from 'react-toastify';
import { useFringeMutation } from 'utils/api/mutations';
import SearchInput from 'components/SearchInput';
import { useDebounce } from 'react-use';
import DeleteFringeGroup from 'components/DeleteFringeGroup';
import {
  useTable,
  useSortBy,
  useRowSelect,
  useGlobalFilter,
} from 'react-table';
import { useTabsQueries } from 'utils/api/queries';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles.scss';
import EditFringe from 'components/EditFringe';
import DeleteFolder from 'components/DeleteFolder';
import CreateFringe from 'components/CreateFringe';
import DeleteMultiFringe from 'components/DeleteFringe';
import { formatCurrency } from 'utils/helper';
import AddGroup from 'components/AddGroup';
import { useLocation } from 'react-router-dom';

const FringesDetails = ({
  onFringeCreated,
  fringes,
  refetch,
  searchTxt,
  setSearchTxt,
  isParentLoading,
  toggleButtons,
}) => {
  // Contexts and Hooks
  const { createTabsMutation } = useHomeScreenContext();
  // Keep React Table's column dependency stable. The full mutation result is
  // recreated on each render and causes useTable's layout reducer to loop.
  const { mutateAsync: duplicateFringe } =
    useFringeMutation.useDuplicateFringeMutation();
  const [budgetName, setBudgetName] = useState('');
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const instanceType = queryParams.get('type') || 'budget';

  // State Variables

  const [showMovePopup, setShowMovePopup] = useState(false);
  const [, setparentId] = useState(null);
  const [parentNames, setparentNames] = useState([]);
  const [products, setProducts] = useState([]);

  const [fringeId, setfringeId] = useState('');
  const [fringeName, setfringeName] = useState('');
  const [fringeAbbreviation, setfringeAbbreviation] = useState('');
  const [fringeDisplayName, setfringeDisplayName] = useState('');
  const [fringeDescription, setfringeDescription] = useState('');
  const [fringeType, setfringeType] = useState('');
  const [fringeValue, setfringeValue] = useState('');
  const [fringeBaseCap, setfringeBaseCap] = useState('');
  const [fringeCapOnTotal, setfringeCapOnTotal] = useState('');
  const [fringeGroup, setfringeGroup] = useState('');

  const [showCreateFringeModal, setShowCreateFringeModal] = useState(false);
  const [showEditBudgetFolder, setShowEditBudgetFolder] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);
  const productsRef = useRef(products);
  const [allTotal, setAllTotal] = useState(0);

  // Fringes Data Fetching
  // const {
  //   data: budget_details,
  //   isLoading,
  //   refetch,
  // } = useFringeQuery.useFringeDetailsQuery({
  //   enabled: shouldCallApi,
  //   filters: searchTxt ? { search: searchTxt } : {},
  // });
  // const budgetData = budget_details?.data;
  // console.log('Budget Data Fringes:', budgetData);

  // Tabs Data Fetching
  const { data: tabsDetails } = useTabsQueries.useOpenTabsQuery({
    enabled: true,
  });
  const tabsData = tabsDetails?.data;

  // useEffect(() => {
  //   if (fringes) {
  //     const newProducts = fringes.map(budget => ({
  //       id: budget.id,
  //       full_name: budget.name,
  //       type: budget.type,
  //       display_name: budget.display_name,
  //       description: budget.description,
  //       abbreviation: budget.abbreviation,
  //       value: parseFloat(budget.value), // Convert string value to a float
  //       base_cap: parseFloat(budget.base_cap), // Convert string cap_value to a float
  //       cap_on_total: parseFloat(budget.cap_on_total), // Use dash if no value
  //       groups: budget.group?.join(', ') || '', // Flatten the group array into a comma-separated string
  //       fringe_total: formatCurrency(budget.cost || 0), // Default to 0 if no cost value
  //     }));
  //     setProducts(newProducts); // Update state with transformed data
  //     setLoading(false); // End loading state
  //   }
  // }, [fringes]);

  useEffect(() => {
    if (fringes) {
      //setLoading(true); // Start loading state
      setProducts(prevProducts => {
        const newProducts = fringes.map(budget => ({
          id: budget.id,
          full_name: budget.name,
          type: budget.type,
          display_name: budget.display_name,
          description: budget.description,
          abbreviation: budget.abbreviation,
          value: parseFloat(budget.value),
          base_cap: parseFloat(budget.base_cap),
          cap_on_total: parseFloat(budget.cap_on_total),
          groups: budget.group?.join(', ') || '',
          fringe_total: formatCurrency(budget.cost || 0),
        }));

        const updatedProducts = prevProducts.map(prevProduct => {
          const updatedProduct = newProducts.find(
            np => np.id === prevProduct.id
          );
          return updatedProduct || prevProduct;
        });

        newProducts.forEach(newProduct => {
          if (!updatedProducts.some(up => up.id === newProduct.id)) {
            updatedProducts.push(newProduct);
          }
        });

        return updatedProducts.filter(up =>
          newProducts.some(np => np.id === up.id)
        );
      });
      setLoading(false);
    }
  }, [fringes]);

  // Effect to Transform and Set Products Data

  const {
    showDeleteFringeGroup,
    showEditFringeGroup,
    setSeletedDelFringe,
    setSelectDelFringeGroup,
    selectedBudget,
    showDeleteFolder,
    makeAciveTabMutation,
    selectTab,
    setOpenTabsList,
    showDeleteFringe,
    hideEditFringeGroupModal,
    hideDeleteFringeGroupModal,
    hasEditAccess,
  } = useHomeScreenContext();

  const handleFringeCreated = () => {
    // setFringeCreated(!fringeCreated); // Toggle the state to trigger useEffect
    onFringeCreated?.();
  };

  // Handle Creating Tabs
  const handleCreateTabs = useCallback(
    async selRowsData => {
      const payload = selRowsData.map(row => ({
        budget: row.id,
      }));

      try {
        const response = await createTabsMutation.mutateAsync(payload);
        const newTabs = response?.data;
        await makeAciveTabMutation.mutateAsync(newTabs[0]?.id);
        setOpenTabsList([...(tabsData || []), ...(newTabs || [])]);

        window.location.href = '/home';
      } catch (error) {
        console.error('Error creating fringe tab:', error);
        toast.error('Failed to create tabs');
      }
    },
    [createTabsMutation, makeAciveTabMutation, setOpenTabsList, tabsData]
  );

  // Handle Checkbox Selection

  const handleSelectRow = (event, row) => {
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedRows(prevSelected => {
        const updatedSelected = [...prevSelected, row.original];
        setAllTotal(
          (updatedSelected || []).reduce((acc, curr) => {
            return (
              acc + (parseFloat(curr.fringe_total.replace(/[^0-9.]/g, '')) || 0)
            );
          }, 0)
        );
        return updatedSelected;
      });
    } else {
      setSelectedRows(prevSelected => {
        const updatedSelected = prevSelected.filter(
          selectedRow => selectedRow.id !== row.original.id
        );
        return updatedSelected;
      });
    }
  };

  // Handle Modal Closure
  const closeFolder = () => {
    setShowCreateFringeModal(false);
    setShowMovePopup(false);
    setShowEditBudgetFolder(false);
    hideEditFringeGroupModal();
    setLoading(false);
    hideDeleteFringeGroupModal();
    refetch(); // Refetch fringes data after closing any folder-related modal
  };

  // Handle Move Popup Closure
  const handleMovePopupClose = () => {
    setShowMovePopup(false);
    // setSelectedRows([]);
    setparentNames([]);
    setparentId(null);
    refetch(); // Refetch fringes data after moving
  };

  // Handle Search Input Change
  const handleSearchChange = event => {
    setSearchTxt(event.target.value);
    // REMOVE: setShouldCallApi(true); and refetch()
  };

  useDebounce(
    () => {
      if (searchTxt) {
        refetch(); // Trigger API call only after debounce
      }
    },
    300, // Adjust debounce delay as needed
    [searchTxt]
  );

  // Handle Create Fringe Modal
  const handleCreateFringe = () => {
    setShowCreateFringeModal(true);
  };

  // Effect to Keep Products Ref Updated
  useEffect(() => {
    // Update the ref value whenever the products state changes
    productsRef.current = products;
  }, [products]);

  // Effect to Reset Selected Rows When Data Changes
  useEffect(() => {
    setSelectedRows(currentRows => (currentRows.length > 0 ? [] : currentRows));
  }, [products]);

  // Columns Definition for React Table

  const columns = useMemo(
    () => [
      {
        Header: (
          <>
            <span
              className="header-txt"
              style={{ marginRight: '5px', marginLeft: '50px' }}
            >
              Full Fringe Name
            </span>
            {/* <Search /> */}
          </>
        ),
        accessor: 'full_name',
        sticky: 'left',
        Cell: ({ row }) => (
          <div
            className={
              row?.original?.type === 'Folder'
                ? 'uname-cell-fringe-group cursorpointer'
                : 'uname-cell-fringe-group cursorpointer'
            }
          >
            <input
              type="checkbox"
              checked={selectedRows.some(
                selectedRow => selectedRow.id === row.original.id
              )}
              style={{
                cursor: 'pointer',
                width: '16px',
                height: '16px',
                margin: '0px 10px 0px 5px',
              }}
              onChange={event => {
                handleSelectRow(event, row);
              }}
              className="custom-checkbox"
            />
            <div
              onClick={event => {
                selectTab(row?.original?.id, row?.original);
                handleCreateTabs([row?.original]);
              }}
            />
            &nbsp;
            <span
              style={{ marginRight: '10px' }}
              onClick={() => {
                if (row?.original?.type === 'Folder') {
                  // setparentNames(prevParents => [
                  //   ...prevParents,
                  //   {
                  //     name: row?.original?.full_name,
                  //     parent_id: row?.original?.id,
                  //     id: row?.original?.parent_id,
                  //   },
                  // ]);
                  setparentNames(prevParents => {
                    // Check if the id already exists in the array
                    const idExists = prevParents.some(
                      parent => parent.id === row?.original?.parent_id
                    );

                    if (!idExists) {
                      // If the id doesn't exist, append the new object
                      return [
                        ...prevParents,
                        {
                          name: row?.original?.full_name,
                          parent_id: row?.original?.id,
                          id: row?.original?.parent_id,
                        },
                      ];
                    } else {
                      // If the id already exists, you can choose to update the existing object or ignore the new one
                      // For example, you might want to update the name property of the existing object:
                      return prevParents.map(parent => {
                        if (parent.id === row?.original?.parent_id) {
                          return {
                            ...parent,
                            name: row?.original?.full_name,
                          };
                        }
                        return parent;
                      });
                      // Alternatively, you can just return the existing state without any changes
                      // return prevParents;
                    }
                  });

                  setparentId(row?.original?.id);
                } else {
                  setfringeId(row?.original?.id);
                  setfringeName(row?.original?.full_name);
                  setfringeAbbreviation(row?.original?.abbreviation);
                  setfringeDisplayName(row?.original?.display_name);
                  setfringeDescription(row?.original?.description);
                  setfringeType(row?.original?.type);
                  setfringeValue(row?.original?.value);
                  setfringeBaseCap(row?.original?.base_cap);
                  setfringeCapOnTotal(row?.original?.cap_on_total);
                  setfringeGroup(row?.original?.groups);

                  // setparentId(row?.original?.id);
                  setShowEditBudgetFolder(true);
                  // window.location.href = '/home';
                }
              }}
            >
              {row.original.full_name}{' '}
            </span>
          </div>
        ),
        sortType: 'caseInsensitiveSort',
        disableSortBy: false,
      },
      {
        Header: 'Display Name',
        accessor: 'display_name',
        sticky: 'left',
        disableSortBy: true,
        Cell: ({ value }) => <div style={{ marginLeft: '2px' }}>{value}</div>,
      },
      {
        Header: 'Abbreviation',
        accessor: 'abbreviation',
        sticky: 'left',
        disableSortBy: true,
        Cell: ({ value }) => <div style={{ marginLeft: '2px' }}>{value}</div>,
      },
      {
        Header: 'Type',
        accessor: 'type',
        sticky: 'left',
        disableSortBy: false,
        Cell: ({ value }) => (
          <div style={{ marginLeft: '2px' }}>{value?.toUpperCase() || ''}</div>
        ),
      },
      {
        Header: 'Value',
        accessor: 'value',
        sticky: 'left',
        disableSortBy: false,
        Cell: ({ row }) => (
          <div style={{ marginLeft: '2px' }}>
            {row.original.type === 'flat fee'
              ? formatCurrency(row.original.value)
              : row.original.value + '%'}
          </div>
        ),
      },
      {
        Header: 'Base Cap',
        accessor: 'base_cap',
        sticky: 'left',
        disableSortBy: true,
        Cell: ({ row }) => (
          <div style={{ marginLeft: '2px' }}>
            {row.original.base_cap || '-'}
          </div>
        ),
      },
      {
        Header: 'Cap On Total',
        accessor: 'cap_on_total',
        sticky: 'left',
        disableSortBy: true,
        Cell: ({ row }) => (
          <div style={{ marginLeft: '2px' }}>
            {row.original.cap_on_total || '-'}
          </div>
        ),
      },
      {
        Header: 'Group(s)',
        accessor: 'groups',
        sticky: 'left',
        disableSortBy: true,
        Cell: ({ row }) => {
          const groupString = row.original.groups || '';

          return (
            <div
              style={{
                marginLeft: '2px',
                whiteSpace: 'normal',
                wordWrap: 'break-word',
                maxWidth: '200px',
              }}
            >
              {groupString || '-'}
            </div>
          );
        },
      },
      {
        Header: 'Fringe Total',
        accessor: 'fringe_total',
        sticky: 'left',
        disableSortBy: false,
        sortType: (rowA, rowB, columnId) => {
          // Parse the values into numbers for comparison
          const valueA = parseFloat(
            rowA.values[columnId]?.toString().replace(/[^0-9.-]+/g, '') || 0
          );
          const valueB = parseFloat(
            rowB.values[columnId]?.toString().replace(/[^0-9.-]+/g, '') || 0
          );

          return valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
        },
        Cell: ({ row }) => (
          <div style={{ marginLeft: '2px' }}>
            {row?.original?.fringe_total
              ? formatCurrency(row?.original?.fringe_total || 0)
              : '-'}
          </div>
        ),
      },
      {
        Header: 'Actions',
        accessor: 'actions',
        sticky: 'left',
        disableSortBy: true,
        Cell: ({ row }) => (
          <div className="folder-actions-wrapper cursorpointer">
            <>
              {row?.original?.type === 'Folder' ? (
                <>
                  <MoveIcon2
                    title="Move"
                    className="move-icon"
                    onClick={() => {
                      setSelectedRows([row?.original]);
                      setShowMovePopup(true);
                    }}
                  />
                </>
              ) : (
                <>
                  <Edit
                    onClick={() => {
                      setfringeId(row?.original?.id);
                      setfringeName(row?.original?.full_name);
                      setfringeAbbreviation(row?.original?.abbreviation);
                      setfringeDisplayName(row?.original?.display_name);
                      setfringeDescription(row?.original?.description);
                      setfringeType(row?.original?.type);
                      setfringeValue(row?.original?.value);
                      setfringeBaseCap(row?.original?.base_cap);
                      setfringeCapOnTotal(row?.original?.cap_on_total);
                      setfringeGroup(row?.original?.groups);

                      // setparentId(row?.original?.id);
                      setShowEditBudgetFolder(true);
                      // setBudgetToRename(row?.original);
                      // showCreateBudgetModal();
                    }}
                  />
                  <DuplicateIcon
                    title="Duplicate"
                    style={{ marginRight: '10px' }}
                    className="ms-2 cursorpointer"
                    onClick={async () => {
                      try {
                        await duplicateFringe(row?.original?.id);
                        toast.success('Fringe duplicated successfully');
                        refetch();
                      } catch (error) {
                        console.error('Error duplicating fringe:', error);
                        toast.error('Failed to duplicate fringe');
                      }
                    }}
                  />
                  <Delete
                    title="Delete"
                    onClick={() => {
                      setSeletedDelFringe([row?.original]);
                    }}
                    // onFringeCreated={handleFringeCreated}
                  />
                </>
              )}
            </>
          </div>
        ),
      },
    ],
    [
      duplicateFringe,
      handleCreateTabs,
      refetch,
      selectTab,
      selectedRows,
      setSeletedDelFringe,
    ]
  );

  useEffect(() => {
    const name = selectedBudget?.name;
    if (name) {
      setBudgetName(name);
    }
  }, [selectedBudget]);

  const filteredProducts = useMemo(() => {
    if (!searchTxt) return products;
    return products.filter(product =>
      product.full_name.toLowerCase().includes(searchTxt.toLowerCase())
    );
  }, [products, searchTxt]);
  // React Table Instance
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data: filteredProducts, // Use memoized filtered data
        sortTypes: {
          caseInsensitiveSort: (rowA, rowB, columnId) => {
            const a = rowA.values[columnId]?.toString().toLowerCase();
            const b = rowB.values[columnId]?.toString().toLowerCase();

            if (a > b) return 1;
            if (a < b) return -1;
            return 0;
          },
        },
        initialState: { pageIndex: 0 },
        disableSortRemove: true,
      },
      useGlobalFilter,
      useSortBy,
      useRowSelect
    );

  return (
    <>
      <div className="budget-details-wrapper mt-3">
        {/* Header Section */}
        <div className="details-header-wrapper">
          <div className="details-left d-flex align-items-center">
            <div className="detail-header">
              {instanceType === 'user'
                ? 'User Fringes'
                : `${budgetName} Fringes`}
            </div>
            <div className="fringe-toggle-container">{toggleButtons}</div>
          </div>
          <div className="d-flex gap-3">
            {loading && (
              <>
                {/* <CircularProgress size={30} thickness={2} color={'info'} /> */}
              </>
            )}
            <SearchInput
              // onChange={handleSearchChange}
              // onFocus={handleSearchChange}
              // onKeyDown={handleKeyDown}
              onChange={handleSearchChange}
              onFocus={handleSearchChange}
              searchVal={searchTxt}
              placeholder={'Filter Fringes...'}
            />
          </div>
          <div className="details-right d-flex align-items-center">
            <button
              label="Add New Fringe"
              type="button"
              className="btn btn-primary new-folder"
              onClick={handleCreateFringe}
              disabled={instanceType === 'budget' && !hasEditAccess()}
            >
              <span
                style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
              >
                <Icon
                  name="PercentIcon"
                  style={{ width: '14px', height: '14px' }}
                />
                Add New Fringe
              </span>
            </button>
          </div>
        </div>
        {/* Loading Indicator */}
        {/* {console.log('Loading:', isParentLoading)} */}
        {!fringes ? (
          <CornerSpinner isLoading size="sm" label="Loading fringe details" />
        ) : (
          <>
            {/* Breadcrumb Navigation */}
            {parentNames?.length > 0 && (
              <div className="folders-path">
                <div
                  className="bud-hed cursorpointer"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  My Budgets
                </div>
                <GreaterArrow />
                {parentNames?.map((item, index) => (
                  <div className="folder-data" key={item}>
                    <FolderIcon />
                    <div
                      className="bud-head cursorpointer"
                      onClick={() => {
                        if (item?.parent_id === null) {
                          window?.location?.reload();
                        } else {
                          setparentId(item?.parent_id);
                          const indexOfParent15 = parentNames.findIndex(
                            parentData =>
                              parentData?.parent_id === item?.parent_id
                          );
                          const newArray =
                            indexOfParent15 !== -1
                              ? parentNames.slice(0, indexOfParent15 + 1)
                              : parentNames;
                          setparentNames(newArray);
                        }
                      }}
                    >
                      {item?.name}
                    </div>
                    {index < parentNames.length - 1 && <GreaterArrow />}
                  </div>
                ))}
              </div>
            )}

            {/* Selected Rows Actions */}
            {selectedRows?.length > 1 && (
              <div className="selected-records-wrapper">
                <div className="sel-rec-item-count">
                  <CrossIcon onClick={() => setSelectedRows([])} />
                  {selectedRows?.length}{' '}
                  {selectedRows?.length === 1 ? 'item' : 'items'} selected
                </div>
                <div
                  style={{
                    marginRight: 'auto',
                    marginLeft: '20px',
                    color: 'black',
                    fontWeight: '1000',
                    fontSize: '1.2em', // Increase size for a bolder look
                  }}
                >
                  Total Amount of Selected Fringes: {formatCurrency(allTotal)}
                </div>

                <img
                  src={remove}
                  alt="remove"
                  style={{
                    width: '20px',
                    height: '20px',
                    cursor: 'pointer',
                    marginTop: '3px',
                    marginRight: '10px',
                  }}
                  onClick={() => {
                    setSelectDelFringeGroup(selectedRows);
                  }}
                />
                {/*<img*/}
                {/*  src={add}*/}
                {/*  alt="add"*/}
                {/*  style={{*/}
                {/*    width: '20px',*/}
                {/*    height: '20px',*/}
                {/*    cursor: 'pointer',*/}
                {/*    marginTop: '2px',*/}
                {/*  }}*/}
                {/*  onClick={() => {*/}
                {/*    setSelectFringeGroup(selectedRows);*/}
                {/*  }}*/}
                {/*/>*/}

                <div className="actions-wrapper">
                  <Delete
                    title="Delete"
                    onClick={() => setSeletedDelFringe(selectedRows)}
                    // onFringeCreated={handleFringeCreated}
                  />
                </div>
              </div>
            )}

            {/* Table Section */}
            <div className="admin-users-body">
              <div
                className={
                  selectedRows?.length > 1
                    ? 'table-container-fringe-groups table-new-height mt-3'
                    : 'table-container-fringe-groups mt-3'
                }
              >
                <table {...getTableProps()} className="table-cls w-100">
                  {/* Table Header */}
                  <thead className="app-users-table-head">
                    {headerGroups?.map(headerGroup => (
                      <tr
                        {...headerGroup.getHeaderGroupProps()}
                        key={headerGroup.id}
                      >
                        {headerGroup.headers?.map(column => (
                          <th
                            {...column.getHeaderProps(
                              column.getSortByToggleProps()
                            )}
                            key={column.id}
                          >
                            {column.render('Header')}
                            <span>
                              &nbsp;
                              {!column.disableSortBy &&
                                (column.isSorted ? (
                                  <span className="sorted-icon-highlight">
                                    {column.isSortedDesc ? (
                                      // Descending: Z-A for text, 9-1 for numbers
                                      column.id === 'value' ||
                                      column.id === 'percentage' ||
                                      column.id === 'flat_amount' ? (
                                        <Icon
                                          name="ArrowUp91Icon"
                                          style={{
                                            width: '12px',
                                            height: '12px',
                                          }}
                                        />
                                      ) : (
                                        <Icon
                                          name="ArrowUpZAIcon"
                                          style={{
                                            width: '12px',
                                            height: '12px',
                                          }}
                                        />
                                      )
                                    ) : // Ascending: A-Z for text, 1-9 for numbers
                                    column.id === 'value' ||
                                      column.id === 'percentage' ||
                                      column.id === 'flat_amount' ? (
                                      <Icon
                                        name="ArrowDown19Icon"
                                        style={{
                                          width: '12px',
                                          height: '12px',
                                        }}
                                      />
                                    ) : (
                                      <Icon
                                        name="ArrowDownAZIcon"
                                        style={{
                                          width: '12px',
                                          height: '12px',
                                        }}
                                      />
                                    )}
                                  </span>
                                ) : (
                                  <Icon
                                    name="SortIcon"
                                    style={{ width: '12px', height: '12px' }}
                                  />
                                ))}
                            </span>
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>
                  {/* Table Body */}
                  {rows && products?.length > 0 ? (
                    <tbody {...getTableBodyProps()} className="table-scroll">
                      {rows.map(row => {
                        prepareRow(row);
                        const isSelected = selectedRows.some(
                          selectedRow => selectedRow.id === row.original.id
                        );
                        return (
                          <tr
                            {...row.getRowProps()}
                            className={`table-body-row ${
                              isSelected ? 'selected-row' : ''
                            }`}
                            key={row.id}
                          >
                            {row.cells.map((cell, cellIndex) => (
                              <td
                                {...cell.getCellProps()}
                                key={cellIndex}
                                style={{
                                  width: cellIndex === 0 ? '20%' : 'auto',
                                  paddingLeft: cellIndex === 0 ? '50px' : '0',
                                }}
                              >
                                {cell.render('Cell')}
                              </td>
                            ))}
                          </tr>
                        );
                      })}
                    </tbody>
                  ) : (
                    <tbody>
                      <tr>
                        <td colSpan={columns.length}>
                          <div className="no-budget-found">
                            {searchTxt ? (
                              <>
                                <div className="no-found-head">
                                  No Fringes Found
                                </div>
                                <div className="no-found-body">
                                  No fringes match your search: "{searchTxt}"
                                </div>
                              </>
                            ) : (
                              <>
                                <div className="no-found-head">
                                  Create a Fringe
                                </div>
                                <div className="no-found-body">
                                  {instanceType === 'user'
                                    ? 'User does not have any fringes.'
                                    : 'You do not have any fringes for this budget'}
                                </div>
                                <button
                                  label="New Budget"
                                  type="button"
                                  className="btn btn-primary new-folder"
                                  onClick={() => setShowCreateFringeModal(true)}
                                  disabled={
                                    instanceType === 'budget' &&
                                    !hasEditAccess()
                                  }
                                >
                                  Add New Fringe
                                </button>
                              </>
                            )}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>
              </div>
            </div>
          </>
        )}
      </div>
      {showDeleteFringeGroup && (
        <DeleteFringeGroup
          showDeleteFringeGroup={showDeleteFringeGroup}
          closeFolder={closeFolder}
          refetch={refetch}
        />
      )}
      {showEditFringeGroup && (
        <AddGroup
          showEditFringeGroup={showEditFringeGroup}
          closeFolder={closeFolder}
          refetch={refetch}
        />
      )}

      {/* Conditional Rendering of Modals */}
      {showDeleteFringe && (
        <DeleteMultiFringe
          onFringeCreated={handleFringeCreated}
          refetch={refetch}
        />
      )}
      {showDeleteFolder && <DeleteFolder refetch={refetch} />}
      {showMovePopup && (
        <MoveBudgets
          showMovePopup={showMovePopup}
          onMoveClose={handleMovePopupClose}
          selBudgets={selectedRows}
          refetch={refetch}
        />
      )}
      {showCreateFringeModal && (
        <CreateFringe
          closeFolder={closeFolder}
          showCreateFringeModal={showCreateFringeModal}
          refetch={refetch}
          onFringeCreated={handleFringeCreated}
        />
      )}
      {showEditBudgetFolder && (
        <EditFringe
          fringeId={fringeId}
          frineName={fringeName}
          fringeAbbreviation={fringeAbbreviation}
          fringeDisplay={fringeDisplayName}
          fringeDescription={fringeDescription}
          fringeType={fringeType}
          fringeValue={fringeValue}
          fringeBaseCap={fringeBaseCap}
          fringeCapOnTotal={fringeCapOnTotal}
          fringeGroup={fringeGroup}
          showCreateFringeModal={showEditBudgetFolder}
          closeFolder={closeFolder}
          refetch={refetch}
        />
      )}
    </>
  );
};

// PropTypes Validation
FringesDetails.propTypes = {
  onFringeCreated: PropTypes.func,
  refetch: PropTypes.func.isRequired,
  fringes: PropTypes.array,
  budgetList: PropTypes.array,
  searchTxt: PropTypes.string,
  setSearchTxt: PropTypes.func,
  isParentLoading: PropTypes.bool,
  row: PropTypes.shape({
    original: PropTypes.shape({
      type: PropTypes.string,
      id: PropTypes.number,
      full_name: PropTypes.string,
      // ... add other properties as needed
    }),
  }),

  // New prop for ToggleButtons
  toggleButtons: PropTypes.node,
};

export default FringesDetails;
